import {Link, Route} from 'react-router-dom';
import React from 'react';
import AuthMiddleware from '../middleware/AuthMiddleware';
import {useSelector} from "react-redux";
import {checkPermission} from "./RouteValidator";
import AddSale from '../../modules/sale/AddSale';
import ManageSales from '../../modules/sale/ManageSales';
import UpdateSale from '../../modules/sale/UpdateSale';
import AddCreditNote from '../../modules/sale/AddCreditNote';
import ManageCreditNotes from '../../modules/sale/ManageCreditNote';
import UpdateCreditNote from '../../modules/sale/UpdateCreditNote';
import ManageQuotation from '../../modules/quotation/ManageQuotation';
import AddQuotation from '../../modules/quotation/AddQuotation';
import UpdateQuotation from '../../modules/quotation/UpdateQuotation';
import ManageDeliveryChallan from '../../modules/quotation/ManageDeliveryChallan';
import AddDeliveryChallan from '../../modules/quotation/AddDeliveryChallan';
import UpdateDeliveryChallan from '../../modules/quotation/UpdateDeliveryChallan';

const GenerateQuotationModuleRoutes = () => {
    const company = useSelector((state: any) => state.company);
    const auth = useSelector((state: any) => state.auth);

    const routes: any = [];

    // Quotations
    if (checkPermission(auth, company, '/quotations/add')) {
        routes.push(
            <Route path={'/quotations/add'} element={
                <AuthMiddleware children={<AddQuotation/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/quotations')) {
        routes.push(
            <Route path={'/quotations'} element={
                <AuthMiddleware children={<ManageQuotation/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/quotations/details/id')) {
        routes.push(
            <Route path={'/quotations/details/:id'} element={
                <AuthMiddleware children={<UpdateQuotation/>}/>
            }/>
        );
    }

    // Credit Note
    if (checkPermission(auth, company, '/delivery-challans/add')) {
        routes.push(
            <Route path={'/delivery-challans/add'} element={
                <AuthMiddleware children={<AddDeliveryChallan/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/delivery-challans')) {
        routes.push(
            <Route path={'/delivery-challans'} element={
                <AuthMiddleware children={<ManageDeliveryChallan/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/delivery-challans/details/id')) {
        routes.push(
            <Route path={'/delivery-challans/details/:id'} element={
                <AuthMiddleware children={<UpdateDeliveryChallan/>}/>
            }/>
        );
    }


    return routes;
}

export default GenerateQuotationModuleRoutes;
